import { render } from "./ManageAsesment.vue?vue&type=template&id=112135ef"
import script from "./ManageAsesment?vue&type=script&lang=js"
export * from "./ManageAsesment?vue&type=script&lang=js"

import "./ManageAsesment.vue?vue&type=style&index=0&id=112135ef&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__